<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row>
          <v-col cols="12" md="4">
            <DateIOSPicker label="Ngày" :date.sync="time" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteBus
              label="Tuyến xe"
              outlined
              dense
              clearable
              hide-details="auto"
              :rules="[$rules.required]"
              @change="onBusChange"
            />
          </v-col>
          <v-col cols="12" md="4">
            <!-- TODO: change this to AutocompleteBusSchedule and find it by id instead -->
            <v-select
              label="Chiều di chuyển"
              v-model="busTimeline"
              :items="busTimelines"
              item-text="title"
              item-value="value"
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              label="Trạng thái"
              v-model="status"
              :items="busStudentAttendanceStatus"
              item-text="title"
              item-value="value"
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12">
            <GradeClassStudentSelect
              :gradeCol="{ cols: 12, md: 4 }"
              :classCol="{ cols: 12, md: 4 }"
              :studentCol="{ cols: 12, md: 4 }"
              @changed="gradeClassStudentChange"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import AutocompleteBus from '@/components/basic/input/AutocompleteBus.vue'

export default {
  components: {
    GradeClassStudentSelect,
    DateIOSPicker,
    AutocompleteBus
  },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {},
      status: '',
      time: moment().toISOString(),
      busTimeline: '',
      selectedBus: {}
    }
  },
  computed: {
    ...mapGetters('constant', ['busTimelines', 'busStudentAttendanceStatus'])
  },
  methods: {
    ...mapActions('BusStudentAttendance', ['findStudentTracking']),
    onBusChange(bus) {
      this.selectedBus = bus
    },
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      if (this.$refs.form.validate()) {
        const array = this.busTimeline && this.busTimeline.split('-')
        let specificDate = moment.utc(this.time)
        let nextDay = specificDate.clone().add(1, 'days').toISOString()
        const params = {
          status: this.status,
          'student.grade': get(this.selectedGrade, 'id'),
          'student.currentClass': get(this.selectedClass, 'id'),
          'student.id': get(this.selectedStudent, 'id'),
          'bus_schedule.periodTime': array && array[0],
          'bus_schedule.direction': array && array[1],
          bus: get(this.selectedBus, 'id'),
          createdAt_gt: this.time,
          createdAt_lt: nextDay
        }
        this.findStudentTracking(params)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
